import React, { useEffect } from 'react'
import Order_Details_Card from '../order_details_card/Order_Details_Card'
import { useDispatch, useSelector } from 'react-redux';
import { getAllOrderDeliver, getAllReturnedOrder } from '../../../../../features/order/orderSlice';
import { decodeId, encodeId, formatDate, formatNewDate } from '../../../../../utils/common';

const Returned = () => {

    const data = [
        {
            order_id: 75843,
            item_no: 1,
            price: 1200,
            date: "13th May | 03:28 pm",
            subtext: "Returned (15th May. 2025)"
        },
        {
            order_id: 989,
            item_no: 3,
            price: 1500,
            date: "15th May | 03:00 pm",
            subtext: "Returned (15th May. 2025)"

        },
        {
            order_id: 75843,
            item_no: 1,
            price: 1200,
            date: "13th May | 03:28 pm",
            subtext: "Returned (15th May. 2025)"

        },
        {
            order_id: 989,
            item_no: 3,
            price: 1500,
            date: "15th May | 03:00 pm",
            subtext: "Returned (15th May. 2025)"

        },
        {
            order_id: 75843,
            item_no: 1,
            price: 1200,
            date: "13th May | 03:28 pm",
            subtext: "Returned (15th May. 2025)"

        },
        {
            order_id: 989,
            item_no: 3,
            price: 1500,
            date: "15th May | 03:00 pm",
            subtext: "Returned (15th May. 2025)"

        },

    ]
    const dispatch = useDispatch();

    const Returned = useSelector((state) => state.order.allReturnedOrders);
    useEffect(() => {
        dispatch(getAllReturnedOrder({}));
    }, [dispatch]);


    return (
        <section className='Returned Ordered'>
            {Returned?.data?.map((item) => {
                return (
                    <Order_Details_Card
                        orderId={item?.Product_Order?.invoice_no || " "}
                        no_of_items={item?.no_of_item || "0"}
                        date={item?.createdAt || new Date()}
                        price={item?.total_amount || "0"}
                        subtext={`${item?.Return_Status?.name} at (${formatNewDate(item?.Product_Order?.Order_History?.returnedAt)})`}
                        // onClick={() => {
                        //     setShowCouponModal(true);
                        // }}
                        baseLike={`/returned-order-details/${encodeId(item?.id)}`}
                        data={item}
                        // baseLike="/returned-order-details"
                        type="returned" />
                )
            })}

            <div className='no_data_main_div'>
                <p className='no_data_text'>No more orders to show</p>
            </div>

        </section>
    )
}

export default Returned
